/* Lightweight product-card label rotation; also handles infinite-scroll cards. */
(function(){
  if(window.__ekCardBadgesBound)return;
  window.__ekCardBadgesBound=true;
  var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)');
  function tick(){
    if(document.hidden||(reduced&&reduced.matches))return;
    document.querySelectorAll('[data-ek-card-badges][data-ek-rotate]').forEach(function(group){
      var card=group.closest('.asc-card');
      if(!group.isConnected||(card&&card.matches(':hover, :focus-within')))return;
      var bounds=group.getBoundingClientRect();
      if(bounds.bottom<0||bounds.top>window.innerHeight||bounds.right<0||bounds.left>window.innerWidth)return;
      var labels=group.querySelectorAll('.ek-card-badge');
      if(labels.length<2)return;
      var current=0;
      for(var i=0;i<labels.length;i++){if(!labels[i].hidden){current=i;break;}}
      labels[current].hidden=true;
      labels[(current+1)%labels.length].hidden=false;
    });
  }
  setInterval(tick,4200);
})();